<div [ngClass]="{'container-sm': isSmallView}">
    <div class="layout small-gap app-layout">
        <div class="section-header no-border layout_one_up_center">
        Welcome, {{ userName }}
        </div>
        <div class="layout_one_up_center">
            <div class="announcement-content-body">
            <b>Note:</b> The USAN application deadline for the <b>December 2026</b> USAN Council meeting is <b>October 23, 2026</b>. Following review at the USAN Council meeting, most applicants can expect a response from the USAN Council before the deadline for the spring INN consultation.
            </div>
        </div>
        <div class="layout_one_up_center">
            <div class="text-content text-content-body">
                <b>Application Instructions</b>
            </div><br>
            <div class="text-content text-content-body">
                Welcome to the USAN Application Portal. This platform simplifies the process of applying for United States Adopted Names (USAN) for pharmaceutical compounds. As an organization administrator, you can review team submissions, manage users, and streamline USAN-related tasks for your entire organization.
            </div>
        </div> 
        <div *ngIf="!loadingComplete || !usersLoadingComplete" class="spinner-div">
            <mat-spinner class="spinner-cls"></mat-spinner>
        </div> 
        <div class="width-100">  
        <div class="section-title">Applications</div>
        <div *ngIf="showResults && hasAnyApplications" >
            <mat-tab-group animationDuration="0ms" (selectedTabChange)="selectAppTypeChange($event)" >
                <mat-tab *ngFor="let appType of appTypes">
                    <ng-template mat-tab-label>
                        <span class="section-title app-tab-title">{{appType}}</span>
                    </ng-template>
                    <ng-template matTabContent>
                        <div class="" *ngIf="appListLength > 0">  
                        <div *ngIf="!isSmallView" class="width-100">              
                            <table mat-table [dataSource]="dataSource" #sort matSort (matSortChange)="sortChangeUpdate($event)">
                                <caption>
                                    <mat-paginator *ngIf="showResults" #paginator [length]="appListLength" [pageSizeOptions]="[5, 10, 20]" 
                                        [pageSize]="defaultAppPageSize" showFirstLastButtons aria-label="Select page of Applications">
                                    </mat-paginator>
                                </caption>
                                <ng-container matColumnDef="form">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Form Type"> Form
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="form-element-outer"><span class="form-element-span text-body">{{element.form}}</span></div> 
                                    </td>
                                </ng-container>
                            
                                <ng-container matColumnDef="applicant">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Applicant"> Applicant </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.applicant}}</span></td>
                                </ng-container>
                            
                                <ng-container matColumnDef="firstSuggestedName">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Suggested Name"> Suggested / Revised Names </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.firstSuggestedName}}</span></td>
                                </ng-container>
                        
                                <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Date"> Date </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.date | date: 'MM/dd/yyyy'}}</span>
                                    </td>
                                </ng-container>
                            
                                <ng-container matColumnDef="negotiator">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Negotiator"> Negotiator </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.negotiator}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="status" *ngIf="appType.includes('Approved')">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Status"> Status </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.status}}</span>
                                    </td>
                                </ng-container>
                                
                                <ng-container matColumnDef="progress">
                                    <th mat-header-cell *matHeaderCellDef> Progress </th>
                                    <td mat-cell *matCellDef="let element">
                                        <span class="progress-container">
                                            <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="3.5"
                                                class="progress-spinner-base"></mat-progress-spinner> 
                                            <mat-progress-spinner mode="determinate" [value]="element.progress" [diameter]="24" [strokeWidth]="3.5"
                                                class="spinner-progress-top"></mat-progress-spinner>
                                        </span> 
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="viewIcon">
                                    <th mat-header-cell *matHeaderCellDef> View </th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button aria-label="View icon" (click)="viewDetails(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="appType.includes('Approved') ? columnsToDisplayWithStatus : columnsToDisplay"></tr>
                                <tr mat-row *matRowDef="let row; columns: appType.includes('Approved') ? columnsToDisplayWithStatus : columnsToDisplay;"  ></tr>
                            </table>
                        </div>  
                        <div *ngIf="isSmallView" class="width-100">
                            <mat-paginator #cardPaginator [pageSizeOptions]="[5, 10, 20]" 
                                [length]="appListLength"  [pageSize]="pageCardSize" (page)="onPageChange($event)">
                            </mat-paginator>
                            <mat-card class="application-card" *ngFor="let app of appCardDataPag"> 
                                <mat-card-content class="application-card-content">
                                    <div class="card-main-section">
                                        <div class="card-main-section-left">
                                            <div class="card-form-name">{{formTypeMap[app.form]}}</div>
                                            <div class="card-sugg-name">{{app.firstSuggestedName}}</div>
                                            <div *ngIf="appType.includes('Approved')" class="card-form-name padding-bottom-5">{{app.status}}<br></div>
                                        </div>
                                        <div class="float-right">
                                            <span class="card-progress-container">
                                                <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="3.5"
                                                    class="progress-spinner-base"></mat-progress-spinner> 
                                                <mat-progress-spinner mode="determinate" [value]="app.progress" [diameter]="24" [strokeWidth]="3.5"
                                                    class="spinner-progress-top"></mat-progress-spinner>
                                            </span> 
                                            <button class="card-icon-cls" mat-icon-button [matMenuTriggerFor]="applicationMenu" aria-label="More details button with a menu"
                                                [matMenuTriggerData]="{'element': app}"> 
                                                <mat-icon class="details-cls">more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="width-100"></div>
                                    <table class="width-100">
                                        <tr>
                                            <td class="card-section-bottom-item">
                                                <div >
                                                    <label class="card-bottom-item-title">Applicant</label>
                                                    <label class="card-bottom-item-value">{{shorten(app.applicant)}}</label>
                                                </div>
                                            </td>
                                            <td class="card-section-bottom-item padding-left-10">
                                                <div >
                                                    <label class="card-bottom-item-title">Negotiator</label>
                                                    <label class="card-bottom-item-value">{{shorten(app.negotiator)}}</label>
                                                </div>
                                            </td>
                                            <td class="card-section-bottom-last-item">
                                                <div >
                                                    <label class="card-bottom-item-title">Date</label>
                                                    <label class="card-bottom-item-value">{{app.date | date: 'MM/dd/yyyy'}}</label>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        </div>
                        <div *ngIf="appListLength === 0">
                            <br><br>No Applications found.
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div *ngIf="loadingComplete && !showResults && !hasAnyApplications" class="applications-no-results">
            No Applications found.
        </div>
        
        <mat-menu #applicationMenu="matMenu" class="menu-containr">
            <ng-template matMenuContent let-item="element">
                <button mat-menu-item *ngIf="isSmallView" (click)="viewDetails(item)">
                    <mat-icon>visibility</mat-icon>
                    <span>View Application</span>
                </button>        
            </ng-template>
        </mat-menu>
        

        <div class="width-100"></div><br><br>
        <div [ngClass]="[isSmallView ? 'users-sectn-div fixed-width' : 'users-sectn-div']">
            <div class="width-100">
                <div class="section-title float-left">Users and Access</div>
                <div class="user-btn-div">
                    <button aria-label="Add user icon" class="user-btn-cls" (click)="addNewUserPopup()">
                        <span class="add-user-span save-btn-lbl">Add New User</span> <mat-icon class="add-user-icon">person_add</mat-icon>
                    </button>
                </div>
            </div> 
            <div *ngIf="showUsers" class="users-table">
                <table mat-table [dataSource]="usersList" #usersSort matSort (matSortChange)="userSortChangeUpdate($event)">
                    <caption></caption>
                    <ng-container matColumnDef="userName" > 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by User name"> User Name</th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.userName}}</span></td>
                    </ng-container>

                    <ng-container matColumnDef="email" *ngIf="!isSmallView"> 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email"> Email Address </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.email}}</span> </td>
                    </ng-container>
                
                    <ng-container matColumnDef="accessType"> <!-- -->
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Access"> Access Type </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.accessType}} </span></td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Status"> Status </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.status}} </span></td>
                    </ng-container>
                
                    <ng-container matColumnDef="change" *ngIf="!isSmallView">
                        <th mat-header-cell *matHeaderCellDef> Edit Access </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button aria-label="Edit Access icon" class="edit-btn-cls" (click)="openEditAccessPopUp(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="remove" *ngIf="!isSmallView">
                        <th mat-header-cell *matHeaderCellDef> Remove </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button aria-label="Remove user icon" (click)="removeUserConfirmPopUp(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="detailsIcon" *ngIf="isSmallView">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button [matMenuTriggerFor]="userMenu" [matMenuTriggerData]="{'element': element}"
                            aria-label="More details button with a menu">
                            <mat-icon class="details-cls">more_vert</mat-icon>
                        </button>
                        </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="!isSmallView ? userColumnsToDisplay : userColumnsToDisplaySmallView"></tr>
                    <tr mat-row *matRowDef="let row; columns: !isSmallView ? userColumnsToDisplay : userColumnsToDisplaySmallView;"></tr>
                </table>
                <mat-paginator #usrPaginator [pageSizeOptions]="[5, 10, 20]" 
                    [length]="userListLength" [pageSize]="userPageSize" (page)="onPageChangeForUsers($event)" showFirstLastButtons>
                </mat-paginator>
            </div>
            <div *ngIf="usersLoadingComplete && !showUsers" class="users-no-results">
                No Users found.
            </div>
        </div> 
        
        <mat-menu #userMenu="matMenu" class="menu-containr">
            <ng-template matMenuContent let-element="element">
            <button mat-menu-item (click)="openEditAccessPopUp(element)"> 
                <mat-icon>edit</mat-icon>
                <span>Edit Access</span>
            </button>        
            <button mat-menu-item (click)="removeUserConfirmPopUp(element)"> 
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
            </ng-template>
        </mat-menu> 

        <ng-template #editAccess>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>User Access</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <h4><span class="user-dialog-sub-header">Edit User Access</span></h4>
                        <div class="width-100">
                            <form [formGroup]="editAccessForm">
                                <label class="user-dialog-sub-header">Please select the user's permission settings.</label>
                                <div class="user-dialog-sub-section">
                                    <div  *ngFor="let item of accessTypesList">
                                        <input type="radio" aria-label="item.val" [id]="item.code" [value]="item.val" 
                                            name="accessTypeSelected" formControlName="accessTypeSelected" (change)="setNewAccessType(item.val)"
                                            [checked] = "currentAccessType === item.val"> 
                                        <label [for]="item.code"><span class="text-body">{{item.desc}}</span></label>
                                    </div>
                                </div>
                            </form>
                            <div class="save-btn-div">
                                <button aria-label="Save changes icon" class="save-btn-cls" (click)="saveAccessTypeChange()" [disabled]="disableSaveBtn()">
                                    <mat-icon>save</mat-icon><span class="save-btn-lbl">Save Changes</span> 
                                </button><br>
                                <button aria-label="Cancel" class="save-btn-cls" (click)="cancelEdit()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #removeUser>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>Remove User</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <div class="width-100">
                            <span class="text-body">Please confirm you want to remove <span class="strong-text">{{removeUserName}}</span> 
                                from your organization. This action will revoke <span class="strong-text">{{removeUserName}}</span>'s 
                                access to the USAN application portal.</span>
                            <div class="save-btn-div">
                                <button aria-label="Remove User" class="save-btn-cls" (click)="deleteUser()">
                                   <span class="save-btn-lbl">Remove User</span> 
                                </button><br>
                                <button aria-label="Cancel" class="save-btn-cls" (click)="cancel()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </ng-template>

        <ng-template #addUser>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>Add User</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <div class="width-100">
                            <form [formGroup]="addUserForm">
                                <div class="width-100">
                                    <div class="half-width">
                                        <mat-form-field appearance="outline">
                                            <mat-label>First Name</mat-label>
                                            <input matInput formControlName="firstName">
                                        </mat-form-field>
                                    </div>
                                    <div class="half-width">
                                        <mat-form-field appearance="outline" class="float-right">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput formControlName="lastName">
                                        </mat-form-field>
                                    </div>   
                                </div>
                                <div >
                                    <mat-form-field appearance="outline" class="width-100">
                                        <mat-label>Email Address</mat-label>
                                        <input matInput formControlName="emailAddress">
                                    </mat-form-field>
                                </div>
                                <div class="width-100">
                                    <label class="user-dialog-sub-header">Please select the user's permission settings</label>
                                    <div class="user-dialog-sub-section" *ngFor="let item of accessTypesList">
                                        <input type="radio" aria-label="item.val" [id]="item.code" [value]="item.val" 
                                            name="accessType-item.code" formControlName="accessType">
                                        <label [for]="item.code"><span class="text-body">{{item.desc}}</span></label>
                                    </div>
                                </div>
                            </form>
                            <div *ngIf="addUserHasError" class="add-user-error-cls">
                                <span class="text-body color-red">{{addUserErrorMsg}}</span>
                            </div>
                            <div class="save-btn-div">
                                <button aria-label="Add User icon" class="save-btn-cls" (click)="addNewUser()" [disabled]="disableAddBtn()">
                                    <mat-icon>save</mat-icon><span class="save-btn-lbl">Add User</span> 
                                </button><br>
                                <button aria-label="Cancel" class="save-btn-cls" (click)="cancelAdd()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>